import { Link } from "react-router-dom";
import "./NotFound.css";

export default function NotFound() {
  return (
    <main className="not-found">
      <div className="noise-code" aria-hidden="true">01001110 01001111 01000100 01000101 / SIGNAL LOST / 01000111 01000010 00101101 00110011 00110011</div>
      <section>
        <span>ERROR / 404</span>
        <h1>이 구역의 신호가<br />소실되었습니다.</h1>
        <p>요청한 기록은 삭제되었거나 현재 노드에서 접근할 수 없습니다.</p>
        <Link to="/">안전 구역으로 복귀 →</Link>
      </section>
    </main>
  );
}
